var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_407",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29227",
    "data-name": "Group 29227",
    transform: "translate(509 10575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -509, -10575)",
    filter: "url(#Ellipse_407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407-2",
    "data-name": "Ellipse 407",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_11_",
    "data-name": "svgexport-17 (11)",
    transform: "translate(-489.608 -10558.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50484",
    "data-name": "Path 50484",
    d: "M28.36,24.12v1.717a2.2,2.2,0,1,0,2.748,2.124.55.55,0,0,0-1.1,0,1.1,1.1,0,1,1-1.1-1.1.549.549,0,0,0,.548-.55v-2.19ZM27.051.563,2.36,10.992,2.785,12,27.479,1.573ZM28.36,2.714V19.729h1.1V2.714Z",
    transform: "translate(1.882 0.02)",
    fill: "#33658a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50485",
    "data-name": "Path 50485",
    d: "M25.952,1.69l-8.233,9.33.823.726,8.23-9.33Zm1.539,1.276L23.1,15.038l1.033.373L28.524,3.339ZM4.938,11.227l-1.05.315,1.645,5.486,1.05-.311Zm-3.269.158v5.486h1.1V11.385Z",
    transform: "translate(1.14 1.231)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50486",
    "data-name": "Path 50486",
    d: "M2.462,11.655v3.294H20.57V11.655Z",
    transform: "translate(1.992 11.935)",
    fill: "#e8ab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50487",
    "data-name": "Path 50487",
    d: "M15.976,6.1a1.724,1.724,0,0,0-1.643,1.583l.015-.068-.994,3.974H2.257A1.655,1.655,0,0,0,.608,13.233v3.844a1.657,1.657,0,0,0,1.651,1.645h22.5A1.639,1.639,0,0,0,26.4,17.062V13.231a.55.55,0,0,0-.037-.2L24.169,7.54a3.2,3.2,0,0,0-.494-.909A1.489,1.489,0,0,0,22.559,6.1Z",
    transform: "translate(0 5.966)",
    fill: "#ffbc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50488",
    "data-name": "Path 50488",
    d: "M9.286,7.157a.55.55,0,0,0-.531.409l-.879,3.294a.55.55,0,0,0,.531.689h2.528V7.157Zm2.746,0v7.855l.089.133a.55.55,0,0,0,.456.245h3.3a.55.55,0,0,0,.546-.548V12.647a.55.55,0,0,0-.041-.216L14.3,7.5a.55.55,0,0,0-.506-.338Z",
    transform: "translate(7.787 7.104)",
    fill: "#33b9ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50489",
    "data-name": "Path 50489",
    d: "M2.21,9.8a.55.55,0,0,0-.543.554V12a.55.55,0,1,0,1.1,0V10.354A.55.55,0,0,0,2.21,9.8Zm2.19,0a.55.55,0,0,0-.539.554V12a.55.55,0,1,0,1.1,0V10.354A.55.55,0,0,0,4.4,9.8Zm2.2,0a.55.55,0,0,0-.539.554V12a.55.55,0,1,0,1.1,0V10.354A.55.55,0,0,0,6.6,9.8Z",
    transform: "translate(1.138 9.943)",
    fill: "#e8ab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50490",
    "data-name": "Path 50490",
    d: "M16.053,19.2a.55.55,0,0,0-.51.348l-1.1,2.742a.55.55,0,0,0-.008.378l.548,1.645a.55.55,0,0,0,.523.375H18.8a.55.55,0,0,0,.523-.375l.546-1.645a.55.55,0,0,0-.008-.378l-1.1-2.742a.55.55,0,0,0-.51-.348ZM15.506.544A2.193,2.193,0,1,0,17.7,2.734,2.2,2.2,0,0,0,15.506.544Z",
    transform: "translate(13.643 0)",
    fill: "#ffbc42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28984",
    "data-name": "Group 28984",
    transform: "translate(22.144 5.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50491",
    "data-name": "Path 50491",
    d: "M12.514,2.926v1.1h3.294v-1.1Z",
    transform: "translate(-9.355 -2.924)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50492",
    "data-name": "Path 50492",
    d: "M13.208,3.042,12.3,3.65l2.192,3.294.917-.608Z",
    transform: "translate(-9.59 -2.797)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50493",
    "data-name": "Path 50493",
    d: "M11.192,4.512v1.1h4.939v-1.1Z",
    transform: "translate(-10.775 -1.218)",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50494",
    "data-name": "Path 50494",
    d: "M11.825,4.6l-.834.714,3.294,3.841.834-.714Z",
    transform: "translate(-10.991 -1.119)",
    fill: "#ff6b6b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50495",
    "data-name": "Path 50495",
    d: "M3.314,5.571A1.646,1.646,0,1,0,4.963,7.218,1.655,1.655,0,0,0,3.314,5.571Z",
    transform: "translate(1.14 5.398)",
    fill: "#ffbc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50496",
    "data-name": "Path 50496",
    d: "M4.717,12.713a3.842,3.842,0,1,0,0,7.685H21.729a3.844,3.844,0,0,0,0-7.685Z",
    transform: "translate(0.285 13.072)",
    fill: "#33658a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50497",
    "data-name": "Path 50497",
    d: "M18.927,13.772a1.647,1.647,0,1,0,1.643,1.645,1.655,1.655,0,0,0-1.643-1.645Zm-4.945,0a1.647,1.647,0,1,0,1.649,1.645,1.651,1.651,0,0,0-1.649-1.645Zm-4.937,0a1.647,1.647,0,1,0,1.647,1.645A1.651,1.651,0,0,0,9.046,13.772Zm-4.939,0a1.647,1.647,0,1,0,1.645,1.645,1.651,1.651,0,0,0-1.645-1.645Z",
    transform: "translate(1.992 14.21)",
    fill: "#dbe9ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.9912edf5069b7cd7c5aa364137598a57.svg";
export { ForwardRef as ReactComponent };